import axios from 'helpers/axios';

export const getVideoAccessLevels = async() => {
    const { data } = await axios.get('/api/adminapi/videoaccesslevels/');

    return data;
}
